<template>
  <div id="tour-booking-form">
    <tour-booking-params
        :tour="tour"
        :tourists="tourists"
        @change="mute_combinations"
        @submit="update_combinations"
    />
    <tour-placement-combinations-list
        v-if="show"
        :tour="tour"
        :tourists="local_tourists"
        :tour_date="selected_date"
        @update_choosed_combination="store_choosed_combinations"
    />
    <tour-booking-modal
        :tour="tour"
        :tour_date="selected_date"        
        :tourists="local_tourists"
        :one_day_price="one_day_price"
        :combinations="choosed_combinations"
        :course="course"
        :currency_name="currency_name"
        :modal_btn="modal_btn"
        :modal_title="modal_title"
        :modal_thanks="modal_thanks"
        :role="role"
    />
  </div>
</template>

<script>
import TourBookingParams from "./TourBookingParams";
import TourPlacementCombinationsList from "./TourPlacementCombinationsList";
import TourBookingModal from "./TourBookingModal";



export default {
  components:{
    TourBookingModal,
    TourBookingParams,
    TourPlacementCombinationsList
  },
  props: {
    tour: Object,
    tourists: Object,
    modal_title: String,
    modal_btn: String,
    modal_thanks: String,
    role: {
      type: String,
      default: 'guest',
    }
  },
  data(){
    return {
      local_tourists: this.tourists,
      selected_date: {},
      state: 'waiting',
      choosed_combinations: [],
      one_day_price: undefined,
      currency_name: undefined,
      course: undefined,
    }
  },

  computed:{
    waiting(){
      return this.state === 'waiting';
    },
    show(){
      return this.state === 'show';
    },
  },

  beforeMount() {
    this.get_course();
  },
  
  methods:{
    update_combinations(tour_date, tourists){
      this.$set(this, 'selected_date', tour_date);
      this.$set(this, 'local_tourists', tourists);
      // console.log('update_combinations', tour_date, tourists);
      this.$set(this, 'state', 'show');
    },
    mute_combinations(tour_date, tourists, one_day_price){
      this.update_combinations(tour_date, tourists);
      this.$set(this, 'state', 'waiting');
      this.$set(this, 'one_day_price', one_day_price);
      // console.log('mute_combinations');
      this.$set(this, 'choosed_combinations', []);
    },
    store_choosed_combinations(combinations){
      this.$set(this, 'choosed_combinations', combinations);
    },
    get_course(){
      let vc = this;
      // Request
      $.ajax({
        url: '/api/v1/get_current_course',
        data: {currency_id: this.tour.currency_id},
        dataType: 'json',
        type: 'GET'
      }).done(function(data){
        console.log("current course.", data);
        vc.$set(vc, 'course', data.course);
        vc.$set(vc, 'currency_name', data.currency_name);
      }).fail(function(jXHR, error){
        console.error("get course error.", jXHR.responseJSON.error);
      });
    },

  }
}
</script>